import http from '../jslibs/axios/http';

//用户管理 用户列表
export const userList = (data) => (http.get('/v1/cms/User', data));

//用户管理 用户详情
export const userDetail = (uuid) => (http.get(`/v1/cms/User/${uuid}`));

//用户管理 用户余额明细
export const userBalanceRecord = (uuid, postData) => (http.get(`/v1/cms/UserBalanceRecord/${uuid}`, postData));